import { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { ApiKeyInput, hasNyrisApiKey, API_KEY_CHANGED_EVENT } from 'components/ApiKeyInput';

interface ApiKeyEntryProps {
  autoFocus?: boolean;
  onDone?: () => void;
  className?: string;
}

/** Neutral API-key entry UI shared by the dedicated page (and nowhere else). */
export function ApiKeyEntry({
  autoFocus = false,
  onDone,
  className,
}: ApiKeyEntryProps): JSX.Element {
  const [canContinue, setCanContinue] = useState(() => hasNyrisApiKey());

  useEffect(() => {
    const onKeyChanged = () => {
      setCanContinue(hasNyrisApiKey());
    };
    window.addEventListener(API_KEY_CHANGED_EVENT, onKeyChanged);
    return () => window.removeEventListener(API_KEY_CHANGED_EVENT, onKeyChanged);
  }, []);

  return (
    <div
      className={twMerge([
        'flex flex-col items-center gap-4 text-center max-w-md w-full px-4',
        className,
      ])}
    >
      <h1 className="text-[#2B2C46] text-lg font-semibold">API key</h1>
      <p className="text-[#AAABB5] text-sm">
        Enter your nyris API key. It is stored for this browser session only.
      </p>
      <ApiKeyInput
        hideLabel
        className="flex w-full justify-center"
        inputClassName="w-full max-w-[280px] border-primary"
        autoFocus={autoFocus}
      />
      <button
        type="button"
        onClick={onDone}
        disabled={!canContinue || !onDone}
        className={twMerge([
          'mt-2 h-10 min-w-[120px] px-6 rounded',
          'text-white text-sm font-medium',
          canContinue && onDone
            ? 'bg-[#2B2C46] hover:opacity-90'
            : 'bg-[#AAABB5] cursor-not-allowed',
        ])}
      >
        Done
      </button>
    </div>
  );
}
